/** Transport failures are recoverable; an explicit server rejection is authoritative. */
export class CallTransportError extends Error {}

type Options = {
  ready: () => boolean;
  ping: () => Promise<unknown>;
  recovering: () => void;
  recovered: () => void;
  lost: (error: unknown) => void;
  intervalMs?: number;
};

/** One request at a time, bounded recovery, and no callbacks after session disposal.
 * The server retains a disconnected resumable member for 60s (75s heartbeat lease).
 */
export function maintainCall({ready,ping,recovering,recovered,lost,intervalMs=20000}: Options) {
  let stopped=false, pending=false, since:number|undefined;
  let next=Date.now()+intervalMs;
  const stop=()=>{stopped=true;clearInterval(timer);};
  const fail=(error:unknown)=>{if(stopped)return;stop();lost(error);};
  const recover=()=>{
    if(since===undefined){since=Date.now();next=Date.now();recovering();}
  };
  const tick=()=>{
    if(stopped)return;
    if(since!==undefined && Date.now()-since>=55000){fail(new CallTransportError('Звонок прервался. Подключитесь снова.'));return;}
    if(!ready()){recover();return;}
    if(pending || Date.now()<next)return;
    pending=true;
    void Promise.resolve().then(ping).then(()=>{
      if(stopped)return;
      const wasRecovering=since!==undefined;
      since=undefined;next=Date.now()+intervalMs;
      if(wasRecovering)recovered();
    }).catch(error=>{
      if(stopped)return;
      if(!(error instanceof CallTransportError)){fail(error);return;}
      recover();next=Date.now()+3000;
    }).finally(()=>{pending=false;});
  };
  const timer=setInterval(tick,1000);
  tick();
  return stop;
}
